import styled, { css } from "styled-components"
import {
  compose,
  color,
  layout,
  position,
  space,
  typography,
  border
} from "styled-system"

/** Button component
 * @param valid props inherits from generateStyle such as padding, margin etc...
 * @param {bool} primary - primary background button with white text
 * @param {string} background - sets background color with color values in theme.
 * @param {string} color - sets text color with color values in theme.
 * @param {string} outline - outlined button. Sets outline and text color with color values in theme.
 *
 * @example - Create primary button
 * <Button bg="primary" color="white">Button</Button>
 * @example - Create grey outline button
 * <Button outline="grey65">Button</Button>
 */
const Button = styled.button.attrs((props) => ({
  type: props.type || "button",
  ...props,
}))`
  display: inline-block;
  padding: 16px 24px;
  font-size: 14px;
  text-align: center;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  ${props =>
    props.text &&
    css`
      padding: 0;
      text-align: left;
      font-size: 12px;
      background: none;
    `};
  ${compose(color, layout, position, space, typography, border)};

  ${props =>
    (props.variant === "primary" || props.primary) &&
    `
    color: ${props.theme.colors.white};
    background-color: ${props.theme.colors.primary};
  `};

  ${props =>
    props.outline &&
    `
      color: ${props.theme.colors[props.outline]};
      border: 1px solid ${props.theme.colors[props.outline]};
    `};

  :active,
  :disabled {
    opacity: 0.6;
  }
  :disabled {
    :active {
      opacity: 1;
    }
  }
`

export default Button
